import styled from "@emotion/styled";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { Link } from "@brexhq/next/src/components/shared/Link";
import { socialDictionary } from "@brexhq/next/src/constants/social";
import allSingleColorIcons from "@brexhq/shared/components/deprecated/Icons/SingleColor/SingleColorIcons";

const iconList = [
  {
    ...socialDictionary.facebook,
    Icon: allSingleColorIcons.Facebook,
  },
  {
    ...socialDictionary.youtube,
    Icon: allSingleColorIcons.Youtube,
  },
  {
    ...socialDictionary.instagram,
    Icon: allSingleColorIcons.Instagram,
  },
  {
    ...socialDictionary.linkedin,
    Icon: allSingleColorIcons.Linkedin,
  },
  {
    ...socialDictionary.twitter,
    Icon: allSingleColorIcons.Twitter,
  },
];

const IconLink = styled(Link)(({ theme }) => ({
  "&:hover": { color: theme.colors.accent.primary.background.default },
}));

const List = styled.ul(({ theme }) => ({
  listStyleType: "none",
  padding: 0,
  margin: `${theme.spacing.LRG.xsml}px 0 0 0`,
  display: "flex",
  columnGap: theme.spacing.LRG.sml,
}));

const Title = styled.span(({ theme }) => ({
  ...theme.typography.BodySmallSB,
  color: theme.colors.content.primary,
}));

export default function SocialLinks() {
  return (
    <Container>
      <Title>Social</Title>
      <List>
        {iconList.map(({ name, url, Icon }) => (
          <li key={name}>
            <IconLink
              component="SocialLinks"
              modifier="unstyled"
              label={name}
              to={url}
              tabIndex={-1}
            >
              <Icon aria-label={name} height={16} />
            </IconLink>
          </li>
        ))}
      </List>
    </Container>
  );
}
